// extracted by mini-css-extract-plugin
module.exports = {"announcements":"P_fy p-2","announcement":"P_fz card my-2","announcement--highlighted":"P_fB","announcement__list-item":"P_fC py-1","announcement__flag":"P_fD"};